var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9672743010"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L32 0L32 32L0 32L0 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath9672743010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.33333C0 0.979711 0.140476 0.640573 0.390524 0.390524C0.640573 0.140476 0.979712 4.44089e-16 1.33333 0L21.3333 0C21.687 8.28802e-09 22.0261 0.140476 22.2761 0.390524C22.5262 0.640573 22.6667 0.979711 22.6667 1.33333L22.6667 14.6667L20 14.6667L20 2.66667L2.66667 2.66667L2.66667 24L10.18 24L10.18 26.6667L1.33333 26.6667C0.979712 26.6667 0.640573 26.5262 0.390524 26.2761C0.140476 26.0261 8.88178e-16 25.687 0 25.3333L0 1.33333Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 4 2.66667)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.66667L0 2.66667L0 0L12 0L12 2.66667ZM8 8L0 8L0 5.33333L8 5.33333L8 8Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 9.33333 9.33333)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 0L2.66667 9.33333L0 9.33333L0 0L2.66667 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 21.3333 20)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.21867 0C5.57226 7.55177e-05 5.91134 0.140601 6.16133 0.390667L10.4373 4.66667L8.552 6.552L5.21867 3.21867L1.88533 6.552L0 4.66667L4.276 0.390667C4.52599 0.140601 4.86507 7.5526e-05 5.21867 0Z",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 17.448 18.6667)",
    fill: "currentColor"
  }))));
};
export default SvgUpload;